
import { defineComponent, ref } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";

export default defineComponent({
  name: "square-badge",
  components: {
    CodeHighlighter
  },
  setup() {
    const colors = ref([
      "white",
      "primary",
      "secondary",
      "success",
      "info",
      "warning",
      "danger",
      "dark"
    ]);

    return {
      colors
    };
  }
});
